import { Routes, Route } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

import { useAuth } from './auth/AuthContext';
import { LoginPage } from './auth/LoginPage';
import { AppLayout } from './layout/AppLayout';
import { DashboardPage } from './pages/DashboardPage';
import { UsersPage } from './pages/UsersPage';
import { PlacesPage } from './pages/PlacesPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { PhotosPage } from './pages/PhotosPage';
import { PlacesModerationPage } from './pages/PlacesModerationPage';
import { ReviewsModerationPage } from './pages/ReviewsModerationPage';
import { ExternalReviewsModerationPage } from './pages/ExternalReviewsModerationPage';
import { ExternalReviewPhotosModerationPage } from './pages/ExternalReviewPhotosModerationPage';
import { ReportsModerationPage } from './pages/ReportsModerationPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { PricesPage } from './pages/PricesPage';
import { ClassifiersPage } from './pages/ClassifiersPage';
import { ExternalIgnoredPage } from './pages/ExternalIgnoredPage';
import { RigaDomeImportPage } from './pages/RigaDomeImportPage';

export function App() {
    const { isLoading, user, isAdmin } = useAuth();

    if (isLoading) {
        return (
            <Box sx={{
                minHeight: '100vh', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
            }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!user || !isAdmin) {
        return <LoginPage />;
    }

    return (
        <AppLayout>
            <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/places" element={<PlacesPage />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/photos" element={<PhotosPage />} />
                <Route path="/moderation/places" element={<PlacesModerationPage />} />
                <Route path="/moderation/reviews" element={<ReviewsModerationPage />} />
                <Route path="/moderation/external-reviews" element={<ExternalReviewsModerationPage />} />
                <Route path="/moderation/external-review-photos" element={<ExternalReviewPhotosModerationPage />} />
                <Route path="/moderation/reports" element={<ReportsModerationPage />} />
                <Route path="/external-ignored" element={<ExternalIgnoredPage />} />
                <Route path="/payments" element={<PaymentsPage />} />
                <Route path="/prices" element={<PricesPage />} />
                <Route path="/classifiers" element={<ClassifiersPage />} />
                <Route path="/external/riga-dome" element={<RigaDomeImportPage />} />
            </Routes>
        </AppLayout>
    );
}
